import './hotel.scss';

import { Outlet } from "react-router-dom";

import { FilterHotelProvider } from "./filter-hotel/filter-hotel.context";

export function Hotel() {
  return (
    <div id="ShellHotel" className="hotel">
       <FilterHotelProvider>
        <Outlet />
      </FilterHotelProvider>
    </div>
  );
}

export default Hotel;
